export enum EFeedbackType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
